import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Search Members in Agreements", -1)
const _hoisted_3 = { class: "row q-gutter-md q-mb-lg" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No matching records found.")
const _hoisted_6 = {
  key: 1,
  class: "q-mb-sm"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("\"")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_agreements_members_search_results = _resolveComponent("agreements-members-search-results")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_input, {
        outlined: "",
        dense: "",
        name: "search",
        modelValue: _ctx.filter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
        color: "primary",
        label: "Search by name or email",
        clearable: "",
        class: "col-grow",
        debounce: "300"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "search" })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (_ctx.membersInAgreements.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_q_icon, {
            name: "warning",
            size: "md"
          }),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.membersInAgreements.length)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_6, [
          _createTextVNode("Found " + _toDisplayString(_ctx.membersInAgreements.length) + " results for for phrase: \"", 1),
          _createElementVNode("i", null, _toDisplayString(_ctx.currentResultFilter), 1),
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_agreements_members_search_results, {
      members: _ctx.membersInAgreements,
      filter: _ctx.filter
    }, null, 8, ["members", "filter"])
  ]))
}